import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EventsStore from '../../stores/EventsStore'
import { Button, Header, Pagination } from 'semantic-ui-react'
import { inject, observer } from 'mobx-react'
import SelectSearch from '../Forms/SelectSearch'

@inject('eventsStore')
@observer
class MenuEquipment extends Component {
  static propTypes = {
    eventsStore: PropTypes.instanceOf(EventsStore)
  }

  handleChangeEquipment = (equipmentPage) => {
    const { eventsStore } = this.props
    eventsStore.setEquipmentPage(equipmentPage)
  }

  handleChangeShowAllEquipment = () => {
    this.props.eventsStore.showAllEquipments(!this.props.eventsStore.showAllEquipment)
  }

  render () {
    const { eventsStore } = this.props
    const { currentForm, equipmentCount, equipmentIndex, menuEquipment } = eventsStore
    if (!currentForm) {
      return <></>
    }
    if (eventsStore.showAllEquipment) {
      return (
        <>
          <Button basic onClick={this.handleChangeShowAllEquipment}>Afficher par équipement</Button>
        </>
      )
    }
    if (menuEquipment.type === 'pagination') {
      return (
        <>
          <Header>{menuEquipment.label}</Header>
          <Pagination
            boundaryRange={0}
            activePage={equipmentIndex}
            ellipsisItem={null}
            firstItem={null}
            lastItem={null}
            siblingRange={10}
            onPageChange={(e, data) => { this.handleChangeEquipment(data.activePage) }}
            totalPages={equipmentCount}
          />
        </>
      )
    }
    if (menuEquipment.type === 'search') {
      const options = this.props.eventsStore.allEquipmentsFromCurrentForm
        .map((formEntry, index) => {
          const texts = []
          for (const searchField of menuEquipment.searchFields) {
            const value = formEntry.getValue(searchField.fieldName, searchField.isFixed)
            if (value) {
              texts.push(value)
            }
          }
          return {
            value: (index + 1),
            text: texts.join(', ')
          }
        })
      return (
        <>
          <Header>{menuEquipment.label}</Header>
          <SelectSearch options={options} value={equipmentIndex} onChange={(e, data) => { this.handleChangeEquipment(data.value) }} />
        </>
      )
    }
    return <></>
  }
}

export default MenuEquipment
